var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1304 24.1252V15.3011L31.3822 15.1545C31.9166 14.8442 32.2354 14.2907 32.2354 13.6734C32.2354 13.056 31.9166 12.5014 31.3822 12.1912L18.4654 4.6878C17.3784 4.05455 16.0259 4.05561 14.9389 4.6878L2.02107 12.1922C1.4877 12.5025 1.16895 13.056 1.16895 13.6734C1.16895 14.2907 1.4877 14.8442 2.02107 15.1555L5.93745 17.4314V22.7216C5.93745 23.9499 6.59832 25.092 7.66082 25.7051L13.0519 28.8129C14.1771 29.461 15.4394 29.7862 16.7016 29.7862C17.9639 29.7862 19.2251 29.4621 20.3513 28.8129L25.7414 25.7051C26.8049 25.0931 27.4658 23.9499 27.4658 22.7216V17.4304L29.2179 16.4125V24.1252C28.7684 24.4312 28.4731 24.9465 28.4731 25.5319C28.4731 26.4712 29.2349 27.233 30.1741 27.233C31.1134 27.233 31.8752 26.4712 31.8752 25.5319C31.8752 24.9475 31.5798 24.4322 31.1304 24.1252ZM25.5544 22.7205H25.5533C25.5533 23.2667 25.2611 23.7745 24.7873 24.0465L19.3972 27.1544C17.7354 28.1117 15.6689 28.1117 14.0082 27.1544L8.61707 24.0465C8.14426 23.7745 7.85101 23.2667 7.85101 22.7205V18.5417L14.9389 22.66C15.4829 22.9755 16.0928 23.1339 16.7027 23.1339C17.3126 23.1339 17.9224 22.9766 18.4664 22.66L25.5544 18.5417V22.7205ZM17.5049 21.0067C17.0098 21.2947 16.3946 21.2947 15.8994 21.0067L3.27801 13.6734L15.8984 6.33998C16.3935 6.05205 17.0087 6.05205 17.5038 6.33998L30.1253 13.6723L17.5049 21.0067Z",
    fill: "url(#paint0_linear_2547_985)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_985",
    x1: 16.7022,
    y1: 4.21326,
    x2: 16.7022,
    y2: 29.7862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.1e789693870922f18534bd6dafefd5ee.svg";
export { ForwardRef as ReactComponent };